type SectionTitleProps = {
  title: string;
  subtitle?: string;
  centered?: boolean;
  onDark?: boolean;
};

export function SectionTitle({ title, subtitle, centered = false, onDark = false }: SectionTitleProps) {
  return (
    <div className={centered ? 'mx-auto max-w-2xl text-center' : 'max-w-xl'}>
      <h2
        className={`font-display text-3xl font-bold leading-tight sm:text-4xl ${
          onDark ? 'text-white' : 'text-ink'
        }`}
      >
        {title}
      </h2>
      {subtitle ? (
        <p className={`mt-4 text-base leading-relaxed sm:text-lg ${onDark ? 'text-blue-100' : 'text-slate-600'}`}>
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
